module.exports = __webpack_public_path__ + "static/media/new4@2x.fa46216e.png";